import React from 'react'
import PropTypes from 'prop-types'

import RaisedButton from 'material-ui/RaisedButton'

export default class EditItemButtons extends React.Component {

  static propTypes = {
    primaryButtonText: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onDelete: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  handleCancelTouchTap = event => {
    event.preventDefault()
    this.props.onCancel()
  }

  handleSaveTouchTap = event => {
    event.preventDefault()
    this.props.onSave()
  }

  handleDeleteTouchTap = event => {
    event.preventDefault()
    this.props.onDelete()
  }

  render() {
    return (
      <div
        style={{ display: 'flex', flexDirection: 'row', height: 32, width: 64,
          marginTop: 8, marginBottom: 8, textTransform: 'none' }}>

        <RaisedButton
          style={styles.button}
          label='Cancel'
          labelColor="rgba(0,0,0,0.55)"
          labelStyle={{ textTransform: 'none' }}
          backgroundColor="rgba(0,0,0,0.05)"
          onTouchTap={this.handleCancelTouchTap} />
        {
          this.props.onDelete
          &&
          <RaisedButton
            style={styles.button}
            label='Delete'
            labelColor="rgba(0,0,0,0.55)"
            labelStyle={{ textTransform: 'none' }}
            backgroundColor="rgba(0,0,0,0.05)"
            onTouchTap={this.handleDeleteTouchTap} />
        }
        <RaisedButton
          style={styles.button}
          label={this.props.primaryButtonText}
          labelColor='#fff'
          labelStyle={{ textTransform: 'none' }}
          backgroundColor='#527da3'
          onTouchTap={this.handleSaveTouchTap} />

      </div>
    )
  }
}

const styles = {
  button: {
    marginRight: 16,
    height: 32,
    width: 64
  }
}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/common/EditItemButtons.js